/**
 * Supabase Realtime Client
 * Usado para chat em tempo real e rastreamento GPS do freteiro.
 *
 * Estrategia: arranca com anon key (publica). Quando o user loga, chamamos
 * autenticarRealtime() que pega JWT custom do backend (assinado com
 * SUPABASE_JWT_SECRET) e seta no socket - RLS passa a reconhecer auth.uid()
 * e libera SELECT em tabelas privadas (pedidos, ofertas, etc). Se o backend
 * nao tem o secret configurado, continua com anon key + fallback polling.
 */
import { createClient } from '@supabase/supabase-js';
import { api } from './api/client';

export const SUPABASE_URL =
  process.env.REACT_APP_SUPABASE_URL || 'https://cttllfbgawdgxxuiuvax.supabase.co';
export const SUPABASE_ANON_KEY =
  process.env.REACT_APP_SUPABASE_ANON_KEY ||
  'sb_publishable_Tb7uFP6nhvsh8JDrxYrlKQ_geMSzMC7';

export const supabaseRT = createClient(SUPABASE_URL, SUPABASE_ANON_KEY, {
  realtime: { params: { eventsPerSecond: 10 } },
});

let renovacaoTimer = null;

/**
 * Pede ao backend um JWT custom e seta no socket Realtime. Re-agenda
 * renovacao automatica 5 min antes de expirar. Idempotente.
 */
export const autenticarRealtime = async () => {
  try {
    const r = await api.fetch('/auth/realtime-token');
    if (!r.ok) {
      // 503 = backend sem secret. Continua com anon key (RLS bloqueia
      // tabelas privadas; usePedidosRealtime cai pro polling fallback).
      return false;
    }
    const { token, expires_in_seconds } = await r.json();
    try { supabaseRT.realtime.setAuth(token); } catch {}
    // Renova 5min antes de expirar (default 60min - 5min = 55min)
    const renovarEm = Math.max(60, (expires_in_seconds || 3600) - 300) * 1000;
    if (renovacaoTimer) clearTimeout(renovacaoTimer);
    renovacaoTimer = setTimeout(() => { autenticarRealtime().catch(() => {}); }, renovarEm);
    return true;
  } catch {
    return false;
  }
};

/** Limpa auth do Realtime (no logout). */
export const limparAuthRealtime = () => {
  if (renovacaoTimer) { clearTimeout(renovacaoTimer); renovacaoTimer = null; }
  try { supabaseRT.realtime.setAuth(null); } catch {}
};
